module.exports = "/images/vendor/flag-icon-css/flags/1x1/dm.svg?664bf04224fd8e022ee0170a8b43b5c8";